import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';
import {FilterCard} from '../../../../atoms/FilterCard/FilterCard';
import {RadioButton} from '../../../../atoms/RadioButton/RadioButton';
import {RadioGroup} from '../../../../atoms/RadioButton/RadioGroup';
import {FilterFlyout} from '../FilterFlyout';
import {FilterFlyoutFooter} from '../FilterFlyoutFooter';

interface Props {
  activeOptionId?: string;
  dataTestId?: string;
  label: string;
  options: Array<{id: string; label: string}>;
  onSelect: (itemId: string) => void;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
  showAsRadioGroup?: boolean;
}

const FlyoutFilters = ({
  activeOptionId,
  dataTestId = 'filterFlyoutDiscountLevel',
  label,
  options,
  onSelect,
  open,
  isOpen,
  hide,
  ...props
}: Props) => {
  const {t} = useTranslation();
  return (
    <FilterCard title={label} disableHorizontalPadding={true} onClick={open}>
      <FilterFlyout
        data-testid={`filterFlyout_${dataTestId}`}
        onClose={hide}
        open={isOpen}
        title={label}
        primaryButtonLabel={t('Submit')}
        secondaryButtonLabel={t('Back')}
        footer={FilterFlyoutFooter}
      >
        <Wrapper
          data-testid={`${dataTestId}Wrapper`}
          {...props}
          $maxHeight={true}
        >
          <StyledRadioGroup data-testid={dataTestId}>
            {options.map(({id, label}) => (
              <RadioButton
                key={id}
                name="sort"
                label={label}
                value={id}
                checked={id === activeOptionId}
                onChange={() => onSelect(id)}
                data-testid={`sort-filter-${id}`}
              />
            ))}
          </StyledRadioGroup>
        </Wrapper>
      </FilterFlyout>
    </FilterCard>
  );
};

export const FilterFlyoutDiscountLevel: FC<Props> = props => {
  return (
    <div data-testid="filterFlyoutSectionDiscount">
      <FlyoutFilters {...props} />
    </div>
  );
};

const Wrapper = styled.div<{$maxHeight?: boolean}>`
  width: 100%;
  ${props => (props.$maxHeight ? 'height: 100%;' : 'margin-top: 1.75rem;')}
  display: flex;
  flex-direction: column;
`;

const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: column;
  gap: 20px;
`;
